<template>
  <div class="course-wrapper">
    <div class="inside-wrapper">
      <div class="title">Learning</div>
      <div class="assigned-courses">
        <div
          style="display: flex;"
          v-for="course in lastThreeAssignedLearningItems"
        >
          <div class="course-date">{{ formatDate(course.created_at) }}</div>
          <div class="course-name">
            {{ course.name }}
          </div>
        </div>
      </div>
      <v-btn class="default-action-btn" :to="link()" small>
        Learning
      </v-btn>
    </div>
  </div>
</template>
<script>
import BaseGrid from "@/components/BaseGrid"
import moment from "moment"
export default {
  components: {
    BaseGrid
  },
  props: {
    userId: { type: Number }
  },

  computed: {
    learningItems() {
      let items = this.$store.getters["learningItems/getLearningItemsByUserId"](
        this.userId
      )
      return items ? items : []
    },
    lastThreeAssignedLearningItems() {
      // Deep copy array so that we do not modify the store data
      let clonedLearningItems = JSON.parse(JSON.stringify(this.learningItems))
      let sortedLearningItems = clonedLearningItems.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at)
      })

      let lastThree = sortedLearningItems.slice(0, 3)
      for (let i = lastThree.length; i < 3; i++) {
        lastThree.push({})
      }
      return lastThree
    },
    imageUrls() {
      return this.completedCourses.map(el => el.badge_url)
    }
  },
  mounted() {
    this.$store.dispatch("courses/loadMemberCourses", {})
    // this.$store.dispatch("courses/loadCourses", {
    //   showTemplates: false,
    //   includeHidden: false
    // })
  },
  methods: {
    formatDate(dateString) {
      if (dateString) {
        let givenDate = new Date(dateString)
        return moment(givenDate).format("MMM D")
      } else {
        return ""
      }
    },
    link() {
      let routeName = this.$router.currentRoute.name
      if (routeName.includes("Mentor")) {
        return { name: "coursesGridMentor", params: { id: this.userId } }
      } else if (routeName.includes("Mentee"))
        return { name: "coursesGridMember" }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

div.title {
  color: $dark-blue;
  display: flex;
  font-family: $main-font-family !important;
  font-style: italic;
  font-size: 1em !important;
  margin-left: 15px;
  margin-top: -25px;
  padding-left: 5px;
  position: absolute;
  text-transform: uppercase;
  width: 100%;
}
div.course-wrapper {
  background-color: $trophy-backgroud;
  border-radius: 25px;
  border-color: $light-grey;
  margin-top: 20px;
  position: relative;
}
div.inside-wrapper {
  padding: 10px;
}
div.assigned-courses {
  padding-bottom: 5px;
}
div.v-sheet {
  background-color: $trophy-backgroud;
  border-radius: 25px;
}
div.course-date {
  color: $light-grey;
  line-height: 49px;
  margin-left: 20px;
  min-width: 49px;
}
div.course-name {
  color: $dark-blue;
  background-color: $dark-beige;
  border-radius: 10px;
  line-height: 30px;
  margin: 6px 20px 6px 0;
  min-height: 36px;
  padding-left: 10px;
  vertical-align: center;
  width: 100%;
}
</style>
